angular.module('animatronApp.settings').directive('upgradePlan', () => {
    return (scope: any) => {
        scope.coupon = {};
    };
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/upgradePlanDirective.ts